// English language package
export default {
  // Common
  'common.confirm': 'OK',
  'common.cancel': 'Cancel',
  'common.submit': 'Submit',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.back': 'Back',
  'common.loading': 'Loading...',
  'common.noData': 'No data',
  'common.success': 'Done',
  'common.error': 'Failed',
  'common.retry': 'Retry',
  'common.more': 'More',
  'common.language': 'Language',
  'common.loginRequired': 'Please login first',
  'common.networkError': 'Network error, please try again later',
  
  // Login page
  'login.title': 'Login',
  'login.register': 'Sign Up',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.loginBtn': 'Login',
  'login.registerBtn': 'Sign Up',
  'login.forgotPassword': 'Forgot?',
  'login.passwordLogin': 'Password Login',
  'login.passwordRegister': 'Password Sign Up',
  'login.loginHint': 'Enter phone & password',
  'login.registerHint': 'Enter phone & password to sign up',
  'login.phonePlaceholder': 'Phone number',
  'login.passwordPlaceholder': 'Password',
  'login.loggingIn': 'Logging in...',
  'login.registering': 'Signing up...',
  'login.hasAccount': 'Have account?',
  'login.noAccount': 'No account?',
  'login.goLogin': 'Login',
  'login.goRegister': 'Sign up',
  'login.loginAgreement': 'Login means you agree to Terms & Privacy',
  'login.registerAgreement': 'Sign up means you agree to Terms & Privacy',
  'login.contactService': 'Support: {tel}',
  'login.phoneRequired': 'Phone required',
  'login.phoneInvalid': 'Invalid phone',
  'login.passwordRequired': 'Password required',
  'login.passwordMinLength': 'Min 6 chars',
  'login.loginSuccess': 'Login success',
  'login.registerSuccess': 'Sign up success',
  'login.loginFailed': 'Login failed, retry later',
  'login.registerFailed': 'Sign up failed, retry later',
  'login.networkError': 'Network error',
  'login.codeSent': 'Code sent',
  'login.sendCodeFailed': 'Failed to send code',
  'login.codeRequired': 'Code required',
  'login.codeLogin': 'Code Login',
  'login.codeLoginHint': 'Enter phone & code',
  'login.codePlaceholder': 'Verification code',
  'login.sending': 'Sending...',
  'login.sendCode': 'Send code',
  'login.usePassword': 'Use password',
  'login.goPassword': 'Password',
  'login.goCode': 'Code',
  'login.areaCode.china': '+86',
  'login.areaCode.usa': '+1',
  'login.areaCode.uk': '+44',
  'login.areaCode.india': '+91',
  'login.areaCode.singapore': '+65',
  'login.areaCode.hongkong': '+852',
  'login.areaCode.taiwan': '+886',
  'login.areaCode.japan': '+81',
  'login.areaCode.korea': '+82',
  'login.areaCode.malaysia': '+60',
  'login.areaCode.thailand': '+66',
  'login.areaCode.vietnam': '+84',
  'login.areaCode.indonesia': '+62',
  'login.areaCode.philippines': '+63',
  'login.areaCode.russia': '+7',
  'login.areaCode.germany': '+49',
  'login.areaCode.france': '+33',
  'login.areaCode.italy': '+39',
  'login.areaCode.spain': '+34',
  'login.areaCode.netherlands': '+31',
  'login.areaCode.sweden': '+46',
  'login.areaCode.norway': '+47',
  'login.areaCode.denmark': '+45',
  'login.areaCode.brazil': '+55',
  'login.areaCode.mexico': '+52',
  'login.areaCode.australia': '+61',
  'login.areaCode.newzealand': '+64',
  'login.areaCode.saudiarabia': '+966',
  'login.areaCode.uae': '+971',
  'login.areaCode.qatar': '+974',
  'login.areaCode.kuwait': '+965',
  'login.areaCode.bahrain': '+973',
  'login.areaCode.oman': '+968',
  'country.china': 'China',
  'country.usa': 'USA',
  'country.uk': 'UK',
  'country.india': 'India',
  'country.singapore': 'Singapore',
  'country.hongkong': 'Hong Kong',
  'country.taiwan': 'Taiwan',
  'country.japan': 'Japan',
  'country.korea': 'Korea',
  'country.malaysia': 'Malaysia',
  'country.thailand': 'Thailand',
  'country.vietnam': 'Vietnam',
  'country.indonesia': 'Indonesia',
  'country.philippines': 'Philippines',
  'country.russia': 'Russia',
  'country.germany': 'Germany',
  'country.france': 'France',
  'country.italy': 'Italy',
  'country.spain': 'Spain',
  'country.netherlands': 'Netherlands',
  'country.sweden': 'Sweden',
  'country.norway': 'Norway',
  'country.denmark': 'Denmark',
  'country.brazil': 'Brazil',
  'country.mexico': 'Mexico',
  'country.australia': 'Australia',
  'country.newzealand': 'New Zealand',
  'country.saudiarabia': 'Saudi Arabia',
  'country.uae': 'UAE',
  'country.qatar': 'Qatar',
  'country.kuwait': 'Kuwait',
  'country.bahrain': 'Bahrain',
  'country.oman': 'Oman',
  
  // Example: Home page
  'home.welcome': 'Welcome',
  'home.title': 'Home',
  'home.pageTitle': 'Home',
  'home.loginRequired': 'Please login',
  'home.orderHistory': 'Order history',
  'home.customerService': 'Support',
  'home.logoutSuccess': 'Logged out',
  'home.greeting': 'Hi, {name}',
  'home.defaultDriver': 'Driver',
  'home.onlineStatus': 'Online',
  'home.completedOrders': 'Today done',
  'home.todayIncome': 'Today income',
  'home.pendingOrders': 'Pending',
  'home.quickFunctions': 'Quick access',
  'home.selectService': 'Select service',
  'home.orderHall': 'Order hall',
  'home.realTimeOrders': 'Live orders',
  'home.phoneOrders': 'Phone orders',
  'home.appointmentManagement': 'Reservations',
  'home.myWallet': 'Wallet',
  'home.incomeWithdraw': 'Income & withdraw',
  'home.orderRecords': 'Orders',
  'home.recordManagement': 'Order records',
  'home.contactService': 'Support: {tel}',
  
  // Order Card
  'orderCard.status.cancelled': 'Cancelled',
  'orderCard.status.calling': 'Calling',
  'orderCard.status.pickingUp': 'Picking up',
  'orderCard.status.arrivedPickup': 'Arrived',
  'orderCard.status.passengerBoarded': 'Boarded',
  'orderCard.status.completed': 'Done',
  'orderCard.status.driverCollected': 'Collected',
  'orderCard.status.unknown': 'Unknown',
  
  'orderCard.payment.paid': 'Paid',
  'orderCard.payment.unpaid': 'Unpaid',
  
  'orderCard.label.departureTime': 'Time',
  'orderCard.label.flightInfo': 'Flight',
  'orderCard.label.departure': 'From',
  'orderCard.label.destination': 'To',
  'orderCard.label.phone': 'Phone',
  'orderCard.label.remark': 'Remark',
  'orderCard.label.amount': 'Amount',
  'orderCard.label.paymentStatus': 'Payment',
  
  'orderCard.remark.adults': '{count} adults',
  'orderCard.remark.children': '{count} kids',
  'orderCard.remark.childSeats': '{count} seats',
  'orderCard.remark.luggage': '{count} bags',
  
  'orderCard.action.grabOrder': 'Grab',
  'orderCard.action.contactPassenger': 'Contact',
  'orderCard.action.arrivedPickup': 'Arrived',
  'orderCard.action.passengerBoarded': 'Boarded',
  'orderCard.action.orderEnd': 'End',
  
  // Airport Transfer - Common
  'airportTransfer.error.fetchFailed': 'Load failed, check network',
  'airportTransfer.error.unknown': 'Unknown error',
  
  // Airport Transfer - List
  'airportTransfer.list.loadingMore': 'Loading...',
  'airportTransfer.list.noMore': 'No more',
  
  // Airport Transfer - Pull to Refresh
  'airportTransfer.pull.activate': 'Release to refresh',
  'airportTransfer.pull.deactivate': 'Pull to refresh',
  'airportTransfer.pull.release': 'Loading...',
  'airportTransfer.pull.finish': 'Refreshed',
  
  // Airport Transfer - Index
  'airportTransfer.index.title': 'Airport Transfer',
  'airportTransfer.index.subtitle': 'Fast orders, easy earn',
  'airportTransfer.index.hallTitle': 'Order Hall',
  'airportTransfer.index.hallDesc': 'View & grab orders',
  'airportTransfer.index.recordTitle': 'My Orders',
  'airportTransfer.index.recordDesc': 'Manage & update orders',
  'airportTransfer.index.tips': 'Tip: Update status timely',
  
  // Airport Transfer - Order Hall
  'airportTransfer.hall.grabbing': 'Grabbing...',
  'airportTransfer.hall.grabSuccess': 'Grabbed',
  'airportTransfer.hall.grabFailed': 'Grab failed',
  'airportTransfer.hall.grabError': 'Error, retry later',
  'airportTransfer.hall.emptyText': 'No orders',
  'airportTransfer.hall.emptyTips': 'Orders update in realtime',
  
  // Airport Transfer - Order Record
  'airportTransfer.record.update': 'Update',
  'airportTransfer.record.processing': 'Processing...',
  'airportTransfer.record.updateFailed': 'Update failed',
  'airportTransfer.record.updateError': 'Error, retry later',
  'airportTransfer.record.emptyText': 'No records',
  'airportTransfer.record.emptyTips': 'Go grab orders',
  
  // Add more translations here...

  // Chat page
  'chat.title': 'Chat with ***{passengerPhoneSuffix}',
  'chat.close': 'Close',
  'chat.loadingMore': 'Loading...',
  'chat.inputPlaceholder': 'Message...',
  'chat.send': 'Send',
  'chat.endedTip': 'Chat ended',
  'chat.unread': 'Unread',
  'chat.sending': '⏳',
  'chat.failed': '×',
  'chat.sendFailed': 'Send failed',
  'chat.networkError': 'Network error',
  'chat.uploadFailed': 'Upload failed',
  'chat.loadFailed': 'Load failed',

  // Message Center
  'messageCenter.title': 'Messages',
  'messageCenter.loginRequired': 'Please login',
  'messageCenter.fetchFailed': 'Load failed',
  'messageCenter.networkError': 'Network error',
  'messageCenter.noMessages': 'No messages',
  'messageCenter.loading': 'Loading...',
  'messageCenter.loadMore': 'Load more',
  'messageCenter.orderType.express': 'Express',
  'messageCenter.orderType.carpool': 'Carpool',
  'messageCenter.orderType.airport': 'Airport',
  'messageCenter.orderType.unknown': 'Unknown',
  'messageCenter.time.justNow': 'Now',
  'messageCenter.time.minutesAgo': '{count}m ago',
  'messageCenter.time.hoursAgo': '{count}h ago',
  'messageCenter.imageMessage': '[Image]',

  // Wallet page
  'wallet.pageTitle': 'Wallet',
  'wallet.accountBalance': 'Balance',
  'wallet.fullTimeDriver': 'Full-time',
  'wallet.availableBalance': 'Available',
  'wallet.frozenBalance': 'Frozen',
  'wallet.nextFreeBalance': 'Next unfreeze',
  'wallet.withdraw': 'Withdraw',
  'wallet.withdrawBtn': 'Withdraw',
  'wallet.billDetails': 'History',
  'wallet.income': 'Income',
  'wallet.expenditure': 'Expense',
  'wallet.noIncomeRecords': 'No income',
  'wallet.noExpenditureRecords': 'No expense',
  'wallet.loadMore': 'More',
  'wallet.loading': 'Loading...',
  'wallet.refreshActivate': 'Release to refresh',
  'wallet.refreshDeactivate': 'Pull to refresh',
  'wallet.refreshRelease': 'Loading...',
  'wallet.refreshFinish': 'Refreshed',
  'wallet.withdrawModalTitle': 'Withdraw',
  'wallet.withdrawAmountPlaceholder': 'Amount',
  'wallet.availableAmountLabel': 'Available:',
  'wallet.alipayAccountPlaceholder': 'Alipay (email/phone)',
  'wallet.realNamePlaceholder': 'Real name',
  'wallet.cancel': 'Cancel',
  'wallet.confirmWithdraw': 'Confirm',
  'wallet.withdrawing': 'Processing...',
  'wallet.withdrawSuccess': 'Request sent',
  'wallet.withdrawFailed': 'Failed',
  'wallet.amountRequired': 'Enter valid amount',
  'wallet.amountMin': 'Min ¥1',
  'wallet.amountExceed': 'Exceeds balance',
  'wallet.accountRequired': 'Alipay required',
  'wallet.accountInvalid': 'Invalid Alipay',
  'wallet.nameRequired': 'Name required',
  'wallet.nameMin': 'Min 2 chars',
  'wallet.nameMax': 'Max 20 chars',
  'wallet.nameInvalid': 'Invalid name',
  'wallet.amountValid': 'Valid',
  'wallet.accountValid': 'Valid',
  'wallet.nameValid': 'Valid',
  'wallet.noWithdrawableBalance': 'No balance to withdraw',
  'wallet.loginExpired': 'Session expired',
  'wallet.getBalanceFailed': 'Get balance failed',
  'wallet.getBillsFailed': 'Get records failed',
  'wallet.refreshFailed': 'Refresh failed',
  'wallet.networkError': 'Network error',
  'wallet.unknownError': 'Unknown error',
  'wallet.receivedFare': 'Fare received',
  'wallet.refund': 'Refund',
  'wallet.withdrawToAlipay': 'To Alipay',
  'wallet.receivedReward': 'Reward received',
  'wallet.other': 'Other',

  // Call Order Page
  'callOrder.tab.pending': 'Pending',
  'callOrder.tab.finished': 'Done',
  'callOrder.dateFilter.all': 'All',
  'callOrder.dateFilter.today': 'Today',
  'callOrder.dateFilter.tomorrow': 'Tomorrow',
  'callOrder.dateFilter.recent3': '3 days',
  'callOrder.dateFilter.more': 'More',
  'callOrder.empty': 'No orders',
  'callOrder.label.amount': 'Amount',
  'callOrder.action.contactPassenger': 'Contact',
  'callOrder.action.playVoice': 'Play',
  'callOrder.message.processing': 'Processing...',
  'callOrder.message.updateSuccess': 'Updated',
  'callOrder.message.updateFailed': 'Failed',
  'callOrder.message.updateError': 'Error, retry later',
  'callOrder.voice.playFailed': 'Play failed',
  'callOrder.voice.noVoice': 'No voice',
  'callOrder.action.arrivedPickup': 'Arrived',
  'callOrder.action.passengerBoarded': 'Boarded',
  'callOrder.action.orderEnd': 'End',
  'callOrder.action.update': 'Update',
  'callOrder.label.flight': 'Flight',
  'callOrder.label.phone': 'Phone',
  'callOrder.detail.loading': 'Loading...',
  'callOrder.detail.orderNotFound': 'Not found',
  'callOrder.detail.fetchFailed': 'Load failed',
  'callOrder.detail.orderInfoMissing': 'Info missing',
  'callOrder.detail.noPickupInfo': 'No pickup info',
  'callOrder.detail.noDestinationInfo': 'No dest info',
  'callOrder.detail.voicePlayFailed': 'Play failed',
  'callOrder.detail.noVoiceInfo': 'No voice',
  'callOrder.detail.processing': 'Processing...',
  'callOrder.detail.operationSuccess': 'Done',
  'callOrder.detail.updateFailed': 'Failed',
  'callOrder.detail.updateError': 'Error, retry',
  'callOrder.detail.invalidFeeAmount': 'Invalid amount',
  'callOrder.detail.confirmNoCash': 'No cash, request online payment?',
  'callOrder.detail.paymentInitiated': 'Payment sent',
  'callOrder.detail.submitFailed': 'Submit failed',
  'callOrder.detail.submitError': 'Error, retry',
  'callOrder.detail.confirmCashReceived': 'Cash received?',
  'callOrder.detail.orderCompleted': 'Completed',
  'callOrder.detail.orderIdCopied': 'ID copied',
  'callOrder.detail.confirm': 'OK',
  'callOrder.detail.cancel': 'Cancel',
  'callOrder.detail.arrivedPickupConfirm': 'Arrived at pickup?',
  'callOrder.detail.passengerBoardedConfirm': 'Boarded, start trip?',
  'callOrder.detail.hint': 'Hint',
  'callOrder.detail.navigation': 'Navigate',
  'callOrder.detail.contactPassenger': 'Contact',
  'callOrder.detail.replayVoice': 'Replay',
  'callOrder.detail.slideArrivePickup': 'Slide: arrived',
  'callOrder.detail.slidePassengerBoarded': 'Slide: boarded',
  'callOrder.detail.slideEndTrip': 'Slide: end trip',
  'callOrder.detail.slideOperation': 'Slide',
  'callOrder.detail.operationSuccessful': 'Done',
  'callOrder.detail.mapLoading': 'Map loading...',
  'callOrder.detail.mapLoadingHint': 'Check network if slow',
  'callOrder.detail.mapLoadFailed': 'Map failed',
  'callOrder.detail.startPoint': 'Start',
  'callOrder.detail.endPoint': 'End',
  'callOrder.detail.paymentWarning': 'Let passenger pay in car',
  'callOrder.detail.fee': 'Fare',
  'callOrder.detail.enterFee': 'Enter fare',
  'callOrder.detail.yuan': '¥',
  'callOrder.detail.feeConfirmationNote': 'Cannot change after',
  'callOrder.detail.noCashPayment': 'No cash, online pay',
  'callOrder.detail.cashReceived': 'Cash received',
  'callOrder.detail.orderNumber': 'ID: ',
  'callOrder.detail.copy': 'Copy',
  'callOrder.detail.completed': 'Done',

  // Free Commission Card
  'freeCard.title': 'Free Card',
  'freeCard.detailTitle': 'Card Detail',
  'freeCard.myTitle': 'Purchased',
  'freeCard.todayReward': 'Today\'s Rewards',
  'freeCard.viewPurchased': 'View Purchased',
  'freeCard.buyModal.title': 'Buy Card',
  'freeCard.buyModal.walletPay': 'Wallet Payment',
  'freeCard.buyModal.walletBalance': '(Balance: ${balance})',
  'freeCard.buyModal.insufficientBalance': 'Insufficient balance. Earn more to purchase',
  'freeCard.buyModal.buyNow': 'Buy Now',
  'freeCard.buyModal.paying': 'Paying...',
  'freeCard.buyModal.paySuccess': 'Payment Success',
  'freeCard.card.name': 'Free Card-{name}',
  'freeCard.card.sellEndDate': 'Sale ends: {date}',
  'freeCard.card.cardId': 'Card ID: {id}',
  'freeCard.card.freeDate': 'Free Date',
  'freeCard.card.freeTimeSlot': 'Free Time: {slot}',
  'freeCard.card.remaining': 'Only {remaining}/{total} left',
  'freeCard.card.price': '${price}',
  'freeCard.card.yuan': 'Yuan',
  'freeCard.status.purchased': 'Purchased',
  'freeCard.status.pending': 'Coming Soon',
  'freeCard.status.ended': 'Ended',
  'freeCard.status.cancelled': 'Cancelled',
  'freeCard.detail.purchaseTimeLeft': 'Time left',
  'freeCard.detail.days': 'days',
  'freeCard.detail.hours': 'h',
  'freeCard.detail.minutes': 'm',
  'freeCard.detail.seconds': 's',
  'freeCard.detail.validTimeLeft': 'Valid until',
  'freeCard.detail.usageInstructions': 'Instructions',
  'freeCard.empty': 'No data',
  'freeCard.channelDetailTitle': 'Card Detail',
  'freeCard.card.city': 'City',
  'freeCard.card.timeSlot': 'Time Slot',
  'freeCard.paySuccess.title': 'Purchase Successful',
  'freeCard.paySuccess.desc': 'You have successfully purchased the card',
  'freeCard.paySuccess.tips': 'Please use within the validity period',
  'freeCard.buyModal.selectPayMethod': 'Select Payment Method',
  'freeCard.buyModal.driverWallet': 'Driver Wallet',
  'freeCard.buyModal.wechatPay': 'WeChat Pay',
  'freeCard.buyModal.balance': 'Balance: ¥{balance}',
  'freeCard.buyModal.insufficientWalletBalance': 'Insufficient wallet balance',
  'freeCard.buyModal.checkingCondition': 'Checking purchase condition...',
  'freeCard.buyModal.notEligible': 'You are not eligible to purchase',
  'freeCard.driverInfo.title': 'Driver Info',
  'freeCard.driverInfo.name': 'Driver Name',
  'freeCard.driverInfo.phone': 'Phone Number',
  'freeCard.driverInfo.vehicleNo': 'Vehicle No.',
  'freeCard.driverInfo.switchAccount': 'Switch Account',

  // Invite Page
  'invite.pageTitle': 'Invite Drivers',
  'invite.recordTitle': 'Invite Record',
  'invite.viewDetail': 'View Details',
  'invite.inviteCount': 'Invited',
  'invite.receivedReward': 'Reward',
  'invite.personUnit': '',
  'invite.yuanUnit': '¥',
  'invite.videoTip': 'How to invite? Watch video tutorial',
  'invite.inviteNow': 'Invite Now',

  // Invite Record Page
  'inviteInfo.pageTitle': 'Invite Records',
  'inviteInfo.recordAndReward': 'Records & Rewards',
  'inviteInfo.noReward': '+ 0¥',

  // Beckon Order Page
  'beckonOrder.pageTitle': 'Beckon Order',
  'beckonOrder.status.idle': 'Waiting',
  'beckonOrder.status.boarded': 'Passenger Boarded',
  'beckonOrder.status.completed': 'Passenger Dropped',
  'beckonOrder.label.driverInfo': 'Driver Info',
  'beckonOrder.label.onTime': 'Pickup Time',
  'beckonOrder.label.startAddress': 'Pickup Location',
  'beckonOrder.label.offTime': 'Dropoff Time',
  'beckonOrder.label.endAddress': 'Dropoff Location',
  'beckonOrder.placeholder.selectTime': 'Select time',
  'beckonOrder.placeholder.searchAddress': 'Search address',
  'beckonOrder.placeholder.notDropped': 'Not dropped',
  'beckonOrder.placeholder.notLocated': 'Not located',
  'beckonOrder.action.boarded': 'Passenger Boarded',
  'beckonOrder.action.dropped': 'Passenger Dropped',
  'beckonOrder.action.newOrder': 'New Order',
  'beckonOrder.loading': 'Processing...',
  'beckonOrder.success.boarded': 'Pickup recorded',
  'beckonOrder.success.completed': 'Order completed',
  'beckonOrder.error.startAddressRequired': 'Please enter pickup address',
  'beckonOrder.error.onTimeRequired': 'Please select pickup time',
  'beckonOrder.error.endAddressRequired': 'Please enter dropoff address',
  'beckonOrder.error.endTimeRequired': 'Please select dropoff time',
  'beckonOrder.error.createFailed': 'Failed to create order',
  'beckonOrder.error.completeFailed': 'Failed to complete order',
  'beckonOrder.error.locateFailed': 'Location failed, please retry',
  'beckonOrder.action.locate': 'Tap to locate',
  'beckonOrder.locating': 'Locating...',
  'beckonOrder.locateSuccess': 'Location success',

  // Home
  'home.beckonOrder': 'Beckon Order',
  'home.beckonOrderDesc': 'Offline street-hail orders',

}
